module.exports = __webpack_public_path__ + "img/1707b4e479f5206d15513a7f0f3a3d65.svg";